import * as React from 'react';
import { SVGProps } from 'react';

const IconInclinometrySizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 5a.5.5 0 0 1 .5.5c0 .945.184 1.934.715 2.836.534.907 1.202 1.332 2 1.713.228.108.555.17.998.23l.19.025c.372.05.796.106 1.189.212.468.125.958.336 1.328.748.38.422.58.994.58 1.736v1.5a.5.5 0 0 1-1 0V13c0-.554-.145-.869-.324-1.067-.187-.208-.466-.35-.844-.452-.324-.087-.673-.133-1.047-.184l-.208-.027c-.423-.059-.904-.133-1.292-.319-.886-.422-1.755-.958-2.432-2.108C2.21 7.75 2 6.573 2 5.5a.5.5 0 0 1 .5-.5ZM14.5 11.5a.5.5 0 0 1-.5-.5c0-.945-.184-1.934-.715-2.836-.534-.907-1.202-1.332-2-1.713-.228-.108-.555-.17-.998-.23l-.19-.025c-.371-.05-.796-.106-1.189-.212-.468-.125-.958-.337-1.328-.748C7.2 4.814 7 4.242 7 3.5v-2a.5.5 0 0 1 1 0v2c0 .554.145.869.324 1.067.187.208.466.35.844.452.324.087.673.134 1.047.183l.208.028c.423.059.904.133 1.292.319.886.422 1.755.958 2.431 2.108C14.791 8.75 15 9.927 15 11a.5.5 0 0 1-.5.5Z"
      fill="var(--color-typo-system)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 1a1 1 0 0 1 1 1v3.5c0 .431.083.702.18.88.094.175.234.318.44.446.471.292 1.144.435 2.077.622l.048.01c.822.164 1.878.376 2.71.922.45.296.851.696 1.133 1.24.279.541.412 1.169.412 1.88V14a1 1 0 1 1-2 0v-2.5c0-.461-.085-.76-.19-.961a1.27 1.27 0 0 0-.453-.487c-.464-.304-1.133-.458-2.054-.643l-.122-.025c-.8-.16-1.814-.361-2.614-.858a3.181 3.181 0 0 1-1.145-1.191C4.136 6.807 4 6.194 4 5.5V2a1 1 0 0 1 1-1Z"
      fill="var(--color-typo-primary)"
    />
  </svg>
);
export default IconInclinometrySizeS;
